/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { BLANK_TRIP_TEMPLATE } from './constants';
import { cloneState } from './utils/stateUtils';

const blankTrip = cloneState(BLANK_TRIP_TEMPLATE);

export default function store() {
    return {
        tripPlanner: {
            preferences: {},
            loading: false,
            directions: null,
            uiFilters: {
                agencies: {},
                activities: {},
                accommodations: {},
                hasFilters: false,
                campsiteUseTypes: {},
                campsiteTypes: {},
                campsiteAmenities: {},
                campsiteElectricityHookup: {},
                campsiteVehicleLength: {},
                campsiteEquipment: {},
                occupants: {},
                inventoryTypes: {},
                tourTypes: {},
                tourAccessible: {},
                tourDifficulty: {},
                tourDuration: {},
                tourPrice: {},
                tourTime: {},
                permitTypes: {},
                reservable: {},
                lastAppliedFilter: null,
            },
            filters: [],
            aggregations: [],
            filtersVisible: false,
            lat: null,
            lng: null,
            latSW: null,
            lngSW: null,
            latNE: null,
            lngNE: null,
            view: 'map',
            searchLocation: null,
            activeDate: null,
            activeDestinationIndex: null,
            activeDestinationMapIndex: null,
            activeDestinationListIndex: null,
            activeDestinationItineraryIndex: null,
            activeItemIndex: null,
            trips: [],
            fg: [],
            tripIdeas: [],
            reservations: {
                camping: null,
                tickets: null,
                permits: null,
            },
            trip: blankTrip,
        },
        tripPlannerSearchSuggestions: {
            suggestions: [],
            inventory_suggestions: [],
        },
        tripPlannerSearchResults: {
            geoResults: [],
            listResults: [],
            inventoryItemDetails: [],
        },
        tripPlannerAggregations: {},
    };
}
